import React, { Fragment } from 'react';

import TeslaFront from '../../../../images/teslaFront.png';
import TeslaSide from '../../../../images/teslaSide.png';

import Heading from '../Shared/Heading';
import WhyDrive from '../Shared/WhyDrive';
import TeslaTop from '../../UberToronto/TeslaTop';
import FleetFaq from '../Shared/FleetFaq';
import WhyWait from '../Shared/WhyWait';
import TorontoFooter from '../../../Layout/TorontoFooter';

import cardEv from './CardContentEv';
import faqEv from './FaqContentEv';

import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import ScrollLock from 'react-scrolllock';
import { useHistory } from 'react-router-dom';
import SFFooter from '../../../Layout/SFFooter';
import LAFooter from '../../../Layout/LAFooter';
import NYCFooter from '../../../Layout/NYCFooter';

const EvContainer = () => {
  const history = useHistory();
  const pathname = history.location.pathname;
  return (
    <Fragment>
      <ScrollLock>
        <div className="landing__scroll">
          <Heading
            header="Autzu EV"
            notes={[
              'Zero Emissions',
              'Earn More',
              'Low-cost Electric Charging'
            ]}
            image={TeslaFront}
            icon={<FontAwesomeIcon icon={faCircle} size="xs" />}
          />
          <WhyDrive
            header="Why Autzu EV?"
            cards={cardEv}
            topView={<TeslaTop pro={true} landing={false} />}
            pro
          />
          <FleetFaq faqContent={faqEv} />
          <WhyWait carImage={TeslaSide} />
          <SFFooter />
        </div>
        {pathname.includes('sf') ? (
          <SFFooter />
        ) : pathname.includes('la') ? (
          <LAFooter />
        ) : (
          <NYCFooter />
        )}
      </ScrollLock>
    </Fragment>
  );
};

export default EvContainer;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/AutzuEVSF/EvContainer.js